<template>
  <div>
    <div class="lxm-login-register__logo">
      <img src="https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png">
    </div>
    <p class="lxm-login-register__logo-text">和 <span class="lxm-login-register__logo-number">{{ registerTeamCount }}</span> 家公益机构一起 开启智慧公益</p>
    <div class="lxm-login-register__content">
      <reg-source-tip></reg-source-tip>
      <input-align-left :type="'text'"
                        :placeholder="'请输入您的机构/团队'"
                        :value="teamName"
                        :transparent="true"
                        :error="state.teamNameError"
                        @input="teamNameChanged"
                        @click="teamNameClicked"></input-align-left>
      <input-align-left :type="'text'"
                        :placeholder="'请输入您的姓名'"
                        :value="adminName"
                        :transparent="true"
                        :error="state.adminNameError"
                        @input="adminNameChanged"
                        @click="adminNameClicked"></input-align-left>
      <input-align-left :type="'email'"
                        :placeholder="'请输入您的邮箱'"
                        :value="email"
                        :transparent="true"
                        :error="state.emailError"
                        @input="emailChanged"
                        @click="emailClicked"></input-align-left>

      <phone-verification :smsTime="state.time.reg"
                          :phone-input-name="'请输入您的手机号'"
                          :phone-input-labelled="false"
                          :input-transparent="true"
                          @rqst-sms="rqstSms"></phone-verification>

      <div class="lxm-login-register__placeholder"></div>

      <input-align-left :type="'password'"
                        :placeholder="'请输入您的密码'"
                        :transparent="true"
                        :value="regPassword"
                        :error="state.regPasswordError"
                        @input="regPasswordChanged"
                        @click="regPasswordClicked"></input-align-left>

      <input-align-left :type="'password'"
                        :transparent="true"
                        :placeholder="'再次输入您的密码'"
                        :value="regPasswordConfirm"
                        :error="state.regPasswordConfirmError"
                        @input="regPasswordConfirmChanged"
                        @click="regPasswordConfirmClicked"></input-align-left>

      <register-agreement></register-agreement>

      <button-primary class="lxm-login-register__primary-button"
                      :text="'免费注册'"
                      :loading="buttonLoading"
                      :disabled="buttonDisabled"
                      @click="clicked"></button-primary>

      <div class="lxm-login-register__btns">
        <span>我已注册过账号</span> <a @click="loginClicked">直接登录</a>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-login-register__logo
    display: block
    padding-top: siz(26)
    img
      width: 100%
  .lxm-login-register__logo-text
    margin-top: siz(30)
    color: #394263
    text-align: center
    font-size: siz(16)
    font-weight: 400
    line-height: siz(26)
    height: siz(26)
  .lxm-login-register__logo-number
    font-size: siz(19)
    color: #F5A623
  .lxm-login-register__content
    width: login-width
    margin: 0 auto
    padding-top: siz(14)
    padding-bottom: siz(40)
  .lxm-login-register__primary-button
    margin-top: siz(26)
  .lxm-login-register__placeholder
    margin-bottom: siz(16)
  .lxm-login-register__btns
    font-size: siz(11)
    text-align: center
    margin-top: siz(8)
    span
      color: grey
    a
      color: login-blue
      text-decoration: underline
</style>

<script>
  import AttachedButton from './common/AttachedButton.vue'
  import ButtonPrimary from './common/ButtonPrimary.vue'
  import InputAlignLeft from './common/InputAlignLeft.vue'
  import PhoneVerification from './common/PhoneVerification.vue'
  import RegSourceTip from './common/RegSourceTip.vue'
  import RegisterAgreement from './common/RegisterAgreement.vue'
  import * as aTypes from '../../store/action-types'
  import * as mTypes from '../../store/mutation-types'
  export default {
    components: {
      AttachedButton,
      ButtonPrimary,
      InputAlignLeft,
      PhoneVerification,
      RegisterAgreement,
      RegSourceTip
    },
    computed: {
      state () {
        return this.$store.state.login
      },
      teamName () {
        return this.$store.state.login.teamName
      },
      adminName () {
        return this.$store.state.login.adminName
      },
      email () {
        return this.$store.state.login.email
      },
      regPassword () {
        return this.$store.state.login.regPassword
      },
      regPasswordConfirm () {
        return this.$store.state.login.regPasswordConfirm
      },
      buttonLoading () {
        return this.$store.state.loading[aTypes.LOGIN_REG_TEAM]
      },
      buttonDisabled () {
        return !this.$store.state.login.verifiedPhone || !this.agreed
      },
      agreed () {
        return this.state.agreed
      },
      registerTeamCount () {
        return this.$store.state.login.registerTeamCount
      }
    },
    mounted () {
      this.$store.dispatch(aTypes.REGISTER_TEAM_COUNT)
    },
    methods: {
      teamNameChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { teamName: e.target.value })
      },
      adminNameChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { adminName: e.target.value })
      },
      emailChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { email: e.target.value })
      },
      teamNameClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { teamNameError: '' })
      },
      adminNameClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { adminNameError: '' })
      },
      emailClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { emailError: '' })
      },
      regPasswordChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { regPassword: e.target.value })
      },
      regPasswordClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { regPassword: '' })
      },
      regPasswordConfirmChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { regPasswordConfirm: e.target.value })
      },
      regPasswordConfirmClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { regPasswordConfirm: '' })
      },
      clicked () {
        this.$store.dispatch(aTypes.LOGIN_REG_TEAM, {
          email: this.email,
          name: this.teamName,
          username: this.adminName,
          password: this.regPassword,
          mobile: this.state.verifiedPhone,
          smsCaptcha: this.state.smsVerifCode,
          passwordConfirm: this.regPasswordConfirm
        })
      },
      rqstSms ({ phone, code, smsType }) {
        this.$store.dispatch(aTypes.LOGIN_RQST_SMS_VALIDATION, {
          key: 'reg',
          phone,
          code,
          smsType
        })
      },
      loginClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push('/auth/login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Register.vue?4269158a